import Card from 'src/models/card/Card'
import Model, { encoders, ID } from 'src/models/model'
import IssuedVoucherPackageVoucher from 'src/models/voucher/IssuedVoucherPackageVoucher'
import Voucher from 'src/models/voucher/Voucher'
import VoucherPackage from 'src/models/voucher/VoucherPackage'
import VoucherType from 'src/models/voucher/VoucherType'

export default class IssuedVoucherPackage extends Model {
  static name = 'IssuedVoucherPackage'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      vouchers: {
        type: [Voucher],
        output: true
      },
      voucherPackage: {
        type: VoucherPackage,
        encode: encoders.hasOne,
        reference: true
      },
      voucherType: {
        type: VoucherType,
        encode: encoders.hasOne,
        reference: true
      },
      card: {
        type: Card,
        required: false
      },
      issuedVoucherPackages: {
        type: [IssuedVoucherPackage],
        allowDestroy: true,
        acceptsNestedAttributes: true
      },
      issuedVoucherPackageVouchers: {
        type: [IssuedVoucherPackageVoucher],
        allowDestroy: true,
        acceptsNestedAttributes: true
      },
      skipCard: {
        type: Boolean,
        local: true,
        default: false
      },
      uid: {
        type: String,
        output: true,
        default: null
      },
      setUserChange: {
        type: Number,
        local: true,
        default: 1
      }
    }

    this.computed = {
      description () {
        return this.uid
      },
      requiresCard () {
        if (this.voucherTypeId) {
          return !!this.voucherType?.barcodeOptions?.require_assigned_card && !this.card
        } else {
          return _.some(this.issuedVoucherPackages.data, issuedVoucherPackage => issuedVoucherPackage.requiresCard)
        }
      },
      user () {
        if (!this.setUserChange) return null

        return _.find(this.issuedVoucherPackages?.data, issuedVoucherPackage => !!issuedVoucherPackage.user)?.user ||
          _.find(this.issuedVoucherPackageVouchers?.data, issuedVoucherPackageVoucher => !!issuedVoucherPackageVoucher?.voucher?.user)?.voucher?.user
      }
    }

    this.queries = {
      issuedVoucherPackageByUid: {
        arguments: {
          uid: {
            type: String,
            required: true
          }
        },
        results: {
          issuedVoucherPackage: IssuedVoucherPackage
        }
      }
    }
  }

  validateCardUid (uid) {
    return !this.voucherType || this.voucherType.validateCardUid(uid)
  }

  setUser (user) {
    _.each(this.issuedVoucherPackages?.data, issuedVoucherPackage => {
      issuedVoucherPackage.setUser(user)
    })
    _.each(this.issuedVoucherPackageVouchers?.data, issuedVoucherPackageVoucher => {
      issuedVoucherPackageVoucher.voucher.setRelated('user', user)
    })
    this.setUserChange++
  }
}
